import { z } from "zod";

export const CollectibleParameterElasticId_Schema = z.number(); // can be negative!
export const ValueId_Schema = z.number(); // can be negative!

export const CollectibleParameterElastic_Schema = z.object({
  id: CollectibleParameterElasticId_Schema,
  name: z.string(),

  valueId: ValueId_Schema,
  value: z.string().nullable(),

  // there are also other properties (valueInt, valueBool, ...), but they are not used
});
